// import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ProductAlertsQuery from 'Query/ProductAlerts.query';
import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    ProductAlertsContainer as SourceProductAlertsContainer
} from 'SourceComponent/ProductAlerts/ProductAlerts.container';
import transformToNameValuePair from 'Util/Form/Transform';
import { fetchMutation, getErrorMessage } from 'Util/Request';

/** @namespace PeggysagePwa/Component/ProductAlerts/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state)
});

/** @namespace PeggysagePwa/Component/ProductAlerts/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
});

/** @namespace PeggysagePwa/Component/ProductAlerts/Container */
export class ProductAlertsContainer extends SourceProductAlertsContainer {
    state = {
        isLoading: false,
        hasInStockAlertSubscribed: false
    };

    containerFunctions = {
        ...this.containerFunctions,
        onSuccess: this.onSuccess.bind(this),
        onError: this.onError.bind(this)
    };

    containerProps() {
        const {
            isSignedIn
        } = this.props;
        const {
            isLoading,
            hasInStockAlertSubscribed
        } = this.state;

        return {
            ...super.containerProps(),
            isSignedIn,
            isLoading,
            hasInStockAlertSubscribed
        };
    }

    onError() {
        // const { showNotification } = this.props;
        // showNotification('info', __('Incorrect data! Please resolve all field validation errors.'));
    }

    /**
     * Subscribe guest on form submit
     * @param form
     * @param fields
     * @returns {Promise<void>}
     */
    async onSuccess(form, fields) {
        const {
            productId,
            showErrorNotification
        } = this.props;

        const {
            email,
            type
        } = transformToNameValuePair(fields);

        this.setState({ isLoading: true });

        const query = ProductAlertsQuery.getProductAlertSubscribeGuestMutation(productId, type, email);

        try {
            const productAlertSubscribe = await fetchMutation(query);

            if (productAlertSubscribe) {
                this.setState({ hasInStockAlertSubscribed: true, isLoading: false });
            }
        } catch (error) {
            this.setState({ isLoading: false });

            showErrorNotification(getErrorMessage(error));
        }
    }

    /**
     * Override
     * @param type
     * @returns {Promise<void>}
     */
    async handlePriceDropSubscribe(type) {
        const {
            productId,
            showErrorNotification,
            showNotification,
            isSignedIn
        } = this.props;

        if (!isSignedIn) {
            showNotification('info', __('Please sign in to subscribe for notification'));
            return;
        }

        this.setState({ isLoading: true });

        const query = ProductAlertsQuery.getProductAlertSubscribeMutation(productId, type);

        try {
            const productAlertSubscribe = await fetchMutation(query);

            if (productAlertSubscribe) {
                this.setState({ hasInStockAlertSubscribed: true, isLoading: false });
            }
        } catch (error) {
            this.setState({ isLoading: false });

            showErrorNotification(getErrorMessage(error));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductAlertsContainer);
